import { render, staticRenderFns } from "./StandardMap.vue?vue&type=template&id=57b788f4&"
import script from "./StandardMap.vue?vue&type=script&lang=js&"
export * from "./StandardMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports